import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./ProductFeature.scss";
class ProductFeature extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}
  handleRedirect = (link) => {
    this.props.history.push(link);
  };
  render() {
    return (
      <>
        <section className="hot-features-area" id="productsDetail">
          <div className="container animated bounceInUp">
            <div
              className="section-header-2 wow fadeIn"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <div className="section-description" style={{ zIndex: 999 }}>
                <p className="features-title">
                  <span>
                    <FormattedMessage id="home.product.a1" />
                    <span style={{ fontWeight: 600 }}>
                      <FormattedMessage id="home.product.a2" />
                    </span>
                  </span>
                </p>
              </div>
            </div>
            <div className="row hot-features">
              <div className="container d-flex justify-content-center">
                <div className="col-md-8">
                  <div className="product-features a5-item">
                    <div className="model-name">
                      <FormattedMessage id="home.product.a3" />
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a4" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a5" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a6" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a7" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a8" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a9" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a10" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a11" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a12" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a13" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a14" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a15" />
                      </div>
                    </div>

                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a16" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a15" />
                      </div>
                    </div>
                    <div className="function-item">
                      <div className="tick-ico">✔</div>
                      <div className="function-name">
                        <FormattedMessage id="home.product.a18" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="col-lg-3">
                <div className="product-features m3-item">
                  <div className="model-name">
                    <FormattedMessage id="home.product.a17" />
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a18" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a19" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a20" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a21" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a22" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a23" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a24" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a25" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a26" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a27" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a28" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a29" />
                    </div>
                  </div>
                  <button
                    className="btn-more"
                    onClick={() => {
                      this.handleRedirect("/order/m3");
                    }}
                  >
                    <FormattedMessage id="home.slider.a4" />
                  </button>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="product-features m1-item">
                  <div className="model-name">
                    <FormattedMessage id="home.product.a31" />
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a32" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a33" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a34" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a35" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a36" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a37" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a38" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a39" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a40" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a41" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a42" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a43" />
                    </div>
                  </div>
                  <button
                    className="btn-more"
                    onClick={() => {
                      this.handleRedirect("/order/m1");
                    }}
                  >
                    <FormattedMessage id="home.slider.a4" />
                  </button>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="product-features m0-item">
                  <div className="model-name">
                    <FormattedMessage id="home.product.a45" />
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a46" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a47" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a48" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a49" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a50" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a51" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a52" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a53" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a54" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a55" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="untick-ico">×</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a56" />
                    </div>
                  </div>
                  <div className="function-item">
                    <div className="tick-ico">✔</div>
                    <div className="function-name">
                      <FormattedMessage id="home.product.a57" />
                    </div>
                  </div>
                  <button
                    className="btn-more"
                    onClick={() => {
                      this.handleRedirect("/order/m0");
                    }}
                  >
                    <FormattedMessage id="home.slider.a4" />
                  </button>
                </div>
              </div> */}
            </div>
          </div>
        </section>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductFeature)
);
